import { render, staticRenderFns } from "./EvidencePhoto.vue?vue&type=template&id=da10cc2e&scoped=true&"
import script from "./EvidencePhoto.vue?vue&type=script&lang=js&"
export * from "./EvidencePhoto.vue?vue&type=script&lang=js&"
import style0 from "./EvidencePhoto.vue?vue&type=style&index=0&id=da10cc2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da10cc2e",
  null
  
)

export default component.exports